module.exports = __webpack_public_path__ + "img/qiandao1.b64b2f1b.png";